import { ESkillSourceType } from "../types/skills";

// NOTE: NSAI-3306 — the Skills UI constants that depend on the source-type
// enum. They live apart from constants/skills.ts on purpose: that file is
// imported BY types/skills.ts for its limits, so importing the enum back into
// it would close a cycle and leave the enum undefined at module init.

// NOTE: Provenance label keys in the `skills` i18n namespace. Both maps are
// typed `Record<ESkillSourceType, string>`, so adding a source to the enum is a
// compile error here rather than an untranslated string in the UI.
export const SKILL_SOURCE_LABEL_KEYS: Readonly<
  Record<ESkillSourceType, string>
> = {
  [ESkillSourceType.AUTHORED]: "sourceType.authored",
  [ESkillSourceType.PASTE]: "sourceType.paste",
  [ESkillSourceType.ZIP]: "sourceType.zip",
  [ESkillSourceType.GITHUB]: "sourceType.github",
  [ESkillSourceType.ORG_CATALOG]: "sourceType.orgCatalog",
};

// NOTE: The short chip form for a dense list row, where the sentence-length
// label above does not fit.
export const SKILL_SOURCE_BADGE_KEYS: Readonly<
  Record<ESkillSourceType, string>
> = {
  [ESkillSourceType.AUTHORED]: "sourceBadge.authored",
  [ESkillSourceType.PASTE]: "sourceBadge.paste",
  [ESkillSourceType.ZIP]: "sourceBadge.zip",
  [ESkillSourceType.GITHUB]: "sourceBadge.github",
  [ESkillSourceType.ORG_CATALOG]: "sourceBadge.orgCatalog",
};

// NOTE: The sources offered in the list's source filter. ORG_CATALOG is absent
// on purpose: nothing can carry it until the catalog ships (NSAI-3311), so
// offering it would be a filter that always returns nothing. A row that somehow
// has it still renders its label through the maps above.
export const SELECTABLE_SKILL_SOURCE_TYPES: readonly ESkillSourceType[] = [
  ESkillSourceType.AUTHORED,
  ESkillSourceType.PASTE,
  ESkillSourceType.ZIP,
  ESkillSourceType.GITHUB,
] as const;
